import React from 'react';
import cn from 'classnames';

import IMAGE_ENABLE_DAC from 'assets/images/modals/enable_dac.png';
import IMAGE_REJECT_DAC from 'assets/images/modals/reject_dac.png';
import Button from 'components/form/Button.component';
import CurrencySign from 'components/price/CurrencySign.component';
import SmsPrice from 'components/price/SmsPrice.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './DacModalContent.module.scss';

const determineDataBenefits = (t) => [
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard1.point1'),
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard1.point2'),
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard1.point3'),
];

const determineDataLoses = (t) => [
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard2.point1'),
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard2.point2'),
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard2.point3'),
  t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard2.point4'),
];

export const DacModalContent = ({ selectNo, selectYes, handleSelection, onRejectDac, onEnableDac }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const DATA_BENEFITS = determineDataBenefits(t);
  const DATA_LOSES = determineDataLoses(t);

  return (
    <div
      data-bem="DacModalContent"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.flex}>
        <div
          className={cn({
            [CN.card]: true,
            [CN.active]: selectYes,
          })}
          role="button"
          onClick={handleSelection}
          tabIndex={0}
        >
          <div className={CN.imageCard}>
            <img src={IMAGE_ENABLE_DAC} className={CN.image} alt="confirmation SMS illustration" />
          </div>
          <div className={CN.content}>
            <div className={CN.cardTitle}>{t('scheduler.smsPreferencesPopup.clientPaperCardModal.card1Title')}</div>

            {DATA_BENEFITS.map((text, index) => (
              <div className={CN.item} key={createNodeKey({ index, text })}>
                {text}
              </div>
            ))}
            <div className={CN.item}>
              <CurrencySign />
              <SmsPrice /> {t('scheduler.smsPreferencesPopup.clientPaperCardModal.bulletsCard1.point4')}
            </div>
            <div className={CN.buttonContainer}>
              <Button variant="primaryForce" onClick={onEnableDac}>
                <div className={CN.buttonGap}>{t('scheduler.smsPreferencesPopup.clientPaperCardModal.card1ConfirmButton')}</div>
              </Button>
            </div>
          </div>
        </div>
        <div
          className={cn({
            [CN.card]: true,
            [CN.active]: selectNo,
          })}
          role="button"
          onClick={handleSelection}
          tabIndex={0}
        >
          <div className={CN.imageCard}>
            <img src={IMAGE_REJECT_DAC} className={CN.image} alt="Paper Cards illustration" />
          </div>
          <div className={CN.content}>
            <div className={CN.cardTitle}>{t('scheduler.smsPreferencesPopup.clientPaperCardModal.card2Title')}</div>
            {DATA_LOSES.map((text, index) => (
              <div className={CN.item} key={createNodeKey({ index, text })}>
                {text}
              </div>
            ))}
            <div className={CN.buttonContainer}>
              <Button variant="outline" onClick={onRejectDac}>
                <div className={CN.buttonGap}>{t('scheduler.smsPreferencesPopup.clientPaperCardModal.card2ConfirmButton')}</div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
